module.exports = __webpack_public_path__ + "static/media/error-icon@3x.9aaaeca4.png";